// Definicion del menu de Administrador, compartida entre App.js (para renderizar la
// navegacion) y la pantalla de Permisos de Menu (para armar el arbol de checkboxes que
// el Administrador usa para configurar que ve el Perfil Administrador). Los `to` de cada
// item hoja son la clave estable que se persiste como permiso (ver PermisosMenuContext).
export const getMenuAdminDefinition = (t) => [
    { label: 'Dashboard General', icon: 'pi pi-th-large', to: '/dashboardGeneral' },
    {
        label: 'Gestión',
        icon: 'pi pi-home',
        items: [
            { label: 'Dashboard', icon: 'pi pi-chart-bar', to: '/' },
            { label: t.Barrios, icon: 'pi pi-map', to: '/TableBarrios' },
            { label: 'Personas', icon: 'pi pi-user', to: '/persona' },
            { label: t.UnidadFuncional, icon: 'pi pi-home', to: '/UnidadFuncional' },
        ]
    },

    {
        label: 'Administración',
        icon: 'pi pi-cog',
        items: [
            {
                label: 'Liquidaciones',
                icon: 'pi pi-dollar',
                items: [
                    { label: 'Gastos', icon: 'pi pi-dollar', to: '/gastos', modulo: 'modGastos' },
                    { label: 'Pago a Proveedores', icon: 'pi pi-wallet', to: '/pagoProveedores', modulo: 'modGastos' },
                    { label: `Asignación de Gastos por ${t.UnidadFuncional}`, icon: 'pi pi-globe', to: '/gastoUnidadFuncional' },
                    { label: `Cargos por ${t.UnidadFuncional}`, icon: 'pi pi-building', to: '/cargoPeriodoUnidadFuncional', modulo: 'modCargoPeriodoUF' },
                    { label: 'Expensas', icon: 'pi pi-shopping-cart', to: '/expensas', modulo: 'modExpensas' },
                    { label: 'Pagos', icon: 'pi pi-credit-card', to: '/formularioPago', modulo: 'modPagos' },
                    { label: 'Planes de Pago', icon: 'pi pi-id-card', to: '/planPago', modulo: 'modPlanesPago' },
                    { label: 'Morosidad', icon: 'pi pi-exclamation-triangle', to: '/morosidad', modulo: 'modPlanesPago' },
                    { label: 'Estado de Cuenta', icon: 'pi pi-file', to: '/estadoCuentaAdmin' },
                ]
            },
            {
                label: 'Operaciones',
                icon: 'pi pi-briefcase',
                items: [
                    { label: 'Visitas', icon: 'pi pi-car', to: '/visitasAdmin', modulo: 'modVisitas' },
                    { label: 'Visitantes Frecuentes', icon: 'pi pi-id-card', to: '/visitantesFrecuentes', modulo: 'modVisitas' },
                    { label: 'Reservas', icon: 'pi pi-calendar', to: '/reservasSUMAdmin', modulo: 'modReservas' },
                    { label: 'Reclamos', icon: 'pi pi-flag', to: '/reclamosAdmin', modulo: 'modReclamos' },
                    { label: 'Infracciones', icon: 'pi pi-exclamation-triangle', to: '/infraccionesAdmin' },
                    { label: 'Mantenimiento', icon: 'pi pi-wrench', to: '/mantenimientoAdmin' },
                    { label: 'Inventario', icon: 'pi pi-box', to: '/materiales', modulo: 'modInventario' },
                    { label: 'Encomiendas', icon: 'pi pi-box', to: '/paquetesAdmin', modulo: 'modPaquetes' },
                    { label: 'Sentencias Judiciales', icon: 'pi pi-id-card', to: '/sentenciaJudicialUnidadFuncional', modulo: 'modSentenciaJudicial' },
                    { label: 'Comunicados', icon: 'pi pi-megaphone', to: '/comunicados', modulo: 'modComunicados' },
                    {
                        label: 'Importaciones',
                        icon: 'pi pi-file-import',
                        items: [
                            { label: 'Tasas Municipales', icon: 'pi pi-building', to: '/tasasMunicipales' },
                            { label: 'Coeficientes', icon: 'pi pi-percentage', to: '/coeficientes' },
                        ]
                    },
                ]
            },
            {
                label: 'Maestros',
                icon: 'pi pi-database',
                items: [
                    { label: 'Proveedores', icon: 'pi pi-user-plus', to: '/proveedores' },
                    { label: 'Usuarios', icon: 'pi pi-users', to: '/gestionUsuarios' },
                ]
            },
            {
                label: 'Estado Financiero',
                icon: 'pi pi-chart-line',
                items: [
                    { label: 'Conceptos', icon: 'pi pi-tags', to: '/estadoFinancieroConceptos' },
                    { label: 'Valores Mensuales', icon: 'pi pi-calendar', to: '/estadoFinancieroValoresMensuales' },
                ]
            },
        ]
    },

    {
        label: 'Configuración',
        icon: 'pi pi-sliders-h',
        items: [
            {
                label: 'Liquidaciones',
                icon: 'pi pi-dollar',
                items: [
                    { label: 'Configuración de Gastos', icon: 'pi pi-external-link', to: '/tipoGasto', modulo: 'modGastos' },
                    { label: 'Grupo Gasto', icon: 'pi pi-link', to: '/grupoGasto', modulo: 'modGastos' },
                    { label: 'Fondos', icon: 'pi pi-compass', to: '/fondos', modulo: 'modFondos' },
                    { label: 'Intereses', icon: 'pi pi-percentage', to: '/intereses' },
                ]
            },
            {
                label: 'General',
                icon: 'pi pi-cog',
                items: [
                    { label: 'Condición IVA', icon: 'pi pi-percentage', to: '/condicionIVA' },
                    { label: 'Tipo Persona', icon: 'pi pi-id-card', to: '/tipoPersona' },
                    { label: 'Tipo Relación Persona', icon: 'pi pi-sitemap', to: '/tipoRelacionPersona' },
                    { label: 'Tipo Vehículo', icon: 'pi pi-car', to: '/tipoVehiculo', modulo: 'modVisitas' },
                    { label: 'Tipo Visita', icon: 'pi pi-tag', to: '/tipoVisita', modulo: 'modVisitas' },
                    { label: 'Tipo Reclamo', icon: 'pi pi-tags', to: '/tiposReclamo', modulo: 'modReclamos' },
                    { label: 'Origen de Envío', icon: 'pi pi-truck', to: '/origenEnvio', modulo: 'modPaquetes' },
                    { label: 'Configuración Reservas', icon: 'pi pi-building', to: '/salones', modulo: 'modReservas' },
                    { label: 'Configuración Mantenimiento', icon: 'pi pi-cog', to: '/configuracionMantenimiento' },
                    { label: 'Configuración de Mails', icon: 'pi pi-envelope', to: '/configuracionMails' },
                    { label: 'Permisos Perfil Administrador', icon: 'pi pi-shield', to: '/permisosMenuPerfilAdministrador' },
                ]
            },
        ]
    },
];
